// extracted by mini-css-extract-plugin
module.exports = {"btnWithAddon":"index_btnWithAddon_2PYLo","btnAddon":"index_btnAddon_1-eic","btnAddonIcon":"index_btnAddonIcon_2gqQX"};